import { Injectable } from '@angular/core';
import { Observable, fromEvent, merge } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: "root"
})
export class ConnectionService {
  /**
   * Emits only on actual online/offline transitions - no initial value.
   * Consumers (e.g. AppComponent) reload the page on reconnect, so an
   * initial synchronous emission of the current state would trigger a
   * reload loop on every page load while online.
   */
  monitor(): Observable<boolean> {
    return merge(
      fromEvent(window, "online").pipe(map(() => true)),
      fromEvent(window, "offline").pipe(map(() => false))
    );
  }
}
